"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'db.operation.create': 'Crear',
    'db.operation.update': 'Actualizar',
    'db.operation.delete': 'Eliminar',
    'db.operation.upsert': 'Upsert',
    'db.operation.createMany': 'Crear varios',
    'db.operation.updateMany': 'Actualizar varios',
    'db.operation.deleteMany': 'Eliminar varios',
    'db.operation.findFirst': 'Encontrar primero',
    'db.operation.findMany': 'Encontrar varios',
    'db.operation.findUnique': 'Encontrar único',
    'db.operation.count': 'Contar',
    'db.operation.aggregate': 'Agregar',
    'db.operation.groupBy': 'Agrupar por',
};
